import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PinMap_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.96652L20 5.05348L25.2427 3.68581C27.1435 3.18996 29 4.6243 29 6.58866V24.3678C29 25.733 28.0783 26.9261 26.7573 27.2707L20 29.0335L12 26.9465L6.75727 28.3142C4.85652 28.81 3 27.3757 3 25.4113V7.63214C3 6.26694 3.92174 5.07389 5.24273 4.72929L12 2.96652ZM13 25.1404L19 26.7057V6.85954L13 5.29432V25.1404ZM11 5.29432V25.1404L6.25242 26.3789C5.61884 26.5442 5 26.0661 5 25.4113V7.63214C5 7.17707 5.30725 6.77939 5.74758 6.66452L11 5.29432ZM21 6.85954V26.7057L26.2524 25.3355C26.6928 25.2206 27 24.8229 27 24.3678V6.58866C27 5.93387 26.3812 5.45576 25.7476 5.62104L21 6.85954Z"
            />
        </SvgStyled>
    );
};

export default PinMap_lg;
